import React, { Component, Fragment, useCallback, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import GridViewModelContainer from '../ProductsView/GridViewModelContainer';
import ListViewModelContainer from '../ProductsView/ListViewModelContainer'
import { updateView} from '../../Actions/ProductListView.action';

const ProductsViewModelContainer = (props) => {
    const dispatch = useDispatch();
    const stateselectedView = useSelector((state) => state.productListView.viewstatus) 
   
    const [viewstatus, setStatusValue] = useState(stateselectedView);
    const updateViewStatus = useCallback(
        (status) => {
            setStatusValue(status);
            dispatch(updateView(status));
        },
        [dispatch]
    );


    return (
        <Fragment>
            <div
                className="columns small-12 switch-view-outer">
                {props.products != "null" && (
                 <div className="switch-product-view">
                    <a 
                    tabIndex="0" 
                    role="button" 
                    aria-pressed={viewstatus == 0} 
                    className={viewstatus == 0 ? "switch grid active" : "switch grid "} 
                    onClick={() => updateViewStatus(0)} 
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault(); 
                            updateViewStatus(0);
                        }
                    }}
                    >
                        <svg>
                            <use href="/ui/images/sprites/brenderup.svg#grid-view"></use>
                        </svg>
                    </a>
                    <a 
                    tabIndex="0" 
                    role="button" 
                    aria-pressed={viewstatus == 1} 
                    className={viewstatus == 1 ? "switch list active" : "switch list "} 
                    onClick={() => updateViewStatus(1)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            updateViewStatus(1);
                        }
                    }}
                
                    >
                        <svg>
                            <use href="/ui/images/sprites/brenderup.svg#list-view"></use>
                        </svg>
                    </a>
                </div>
            )}
           
            {viewstatus == 1 ?
                <ListViewModelContainer excludeparsing={false} heading={props.heading} products={props.products} authenticated={props.authenticated} hidedescription={props.hidedescription} isClickAndCollect={props.isClickAndCollect} disableSchemaMarkup={props.disableSchemaMarkup} useToggle={props.useToggle} showAllProductInList={props.showAllProductInList}></ListViewModelContainer>
                :
                <GridViewModelContainer excludeparsing={false} heading={props.heading} products={props.products} authenticated={props.authenticated} hidedescription={props.hidedescription} isClickAndCollect={props.isClickAndCollect} disableSchemaMarkup={props.disableSchemaMarkup} useToggle={props.useToggle} showAllProductInList={props.showAllProductInList}></GridViewModelContainer>
            }
            </div>
        </Fragment>
        

    );
}

export default ProductsViewModelContainer;
